"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _TableContainer = _interopRequireDefault(require("@mui/material/TableContainer/TableContainer.js"));

var _Paper = _interopRequireDefault(require("@mui/material/Paper/Paper.js"));

var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles/makeStyles.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)({
  root: function root(_ref) {
    var width = _ref.width,
        margin = _ref.margin;
    return {
      padding: 0,
      boxShadow: 'rgba(0, 0, 0, 0.14) 0px 0px 20px',
      width: width,
      margin: margin
    };
  }
});

var TableContainer = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var width = props.width,
      margin = props.margin,
      children = props.children,
      className = props.className;

  var _useStyles = useStyles({
    width: width,
    margin: margin
  }),
      root = _useStyles.root;

  return /*#__PURE__*/_react.default.createElement(_TableContainer.default, {
    ref: ref,
    className: "".concat(root, " ").concat(className),
    component: _Paper.default
  }, children);
});

exports.TableContainer = TableContainer;